export default "__VITE_ASSET__DNfy1VVR__"